import { ioExtend } from '@framework';

export class LanguageModel {
    Code:  string = null;
    Name:  string = null;
    Flag?:  string = null;

    constructor(_language?: {}) {
        ioExtend(this, _language);
    };

}